import { Component, EventEmitter, Input, Output } from '@angular/core';
import * as _ from 'lodash';

@Component({
  selector: 'spark-shared-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class SparkSharedPaginationComponent {
  @Input() currentPage = 1;
  @Input() count = 50;
  @Input() size = 10;

  @Output() gotoPage = new EventEmitter<number>();

  readonly MAX_PAGES_TO_DISPLAY = 5;

  get totalNoOfPages() {
    return Math.ceil(this.count / this.size);
  }

  get stepsToLastPage() {
    return this.totalNoOfPages - this.currentPage;
  }

  get lowestPageNo() {
    return Math.max(this.highestPageNo + 1 - this.MAX_PAGES_TO_DISPLAY, 1);
  }

  get highestPageNo() {
    if (this.stepsToLastPage <= 2) {
      return this.totalNoOfPages;
    }
    return this.currentPage + 2;
  }

  get firstPage() {
    return this.currentPage === 1;
  }

  get lastPage() {
    return this.currentPage === this.totalNoOfPages;
  }

  get pages() {
    const leftBound = Math.max(this.currentPage - this.MAX_PAGES_TO_DISPLAY, 1);
    let leftSteps = this.currentPage - leftBound;

    const rightBound = Math.min(
      this.currentPage + this.MAX_PAGES_TO_DISPLAY,
      this.totalNoOfPages
    );
    let rightSteps = rightBound - this.currentPage;

    while (leftSteps + rightSteps >= this.MAX_PAGES_TO_DISPLAY) {
      if (leftSteps > rightSteps) {
        leftSteps--;
      } else {
        rightSteps--;
      }
    }
    return _.range(
      this.currentPage - leftSteps,
      this.currentPage + rightSteps + 1
    );
  }

  goto(page: number) {
    if (this.currentPage !== page) {
      this.currentPage = page;
      this.gotoPage.emit(page);
    }
  }
}
